const angular = require('angular')
const signatureCtrl = require('./signatureCtrl')
const signatureService = require('./signatureService')

module.exports = angular
  .module('hxphone.signature', [])
  .factory('signatureService', signatureService)
  .controller('signatureCtrl', signatureCtrl)



// WEBPACK FOOTER //
// ./src/js/setting/signature/module.js